import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ActivatedRoute, Router, Routes} from '@angular/router';
import { throwError } from 'rxjs/internal/observable/throwError';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../../_services/authentication.service';
import {Permission} from "../../_guards/Permission";

@Component({
  selector: 'app-login',
  templateUrl: './Login.component.html'
})
export class LoginComponent implements OnInit {
  environment = environment;
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  registrazione: boolean = environment.Modules.Registrazione;
  mostrapassword: boolean;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private permission:Permission,
    private authenticationService: AuthenticationService,
  ) {
    if (
      this.authenticationService.currentUserValue &&
      (!this.authenticationService.currentUserValue.two_factor || this.authenticationService.currentUserValue.verified)
    )
        this.router.navigate([this.route.snapshot.queryParams[environment.baseUrl] || environment.baseUrl,])
    else
      this.authenticationService.logout();
  }
  ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
        this.returnUrl = this.route.snapshot.queryParams[' returnUrl '] ;
  }
  get f() { return this.loginForm.controls; }
  onSubmit() {
    if (this.loginForm.invalid)
      return;
    this.submitted = true;
    this.loading = true;
    this.authenticationService.login(this.f.username.value, this.f.password.value).subscribe(user => {
      if (user)
        this.router.navigate([this.route.snapshot.queryParams[this.returnUrl || this.homepage(user)] || (this.returnUrl || this.homepage(user)),])
      this.loading = false;
      }, error => {
          this.errorHandl(error)
          this.loading = false;
      });
    }
  errorHandl(error) {
    let errorMessage = error.error instanceof ErrorEvent ?
      error.error.message :
      `Error Code: ${error.status}\nMessage: ${error.message}`;
    this.error = errorMessage;
    console.log(errorMessage);
    return throwError(errorMessage);
  }
  showforgot() {
    this.router.navigate(["/Login/forgot"]);
  }
  homepage(user): string {
    if (user.two_factor && environment.Modules.twoFactorAuth)
      return "/Login/verify";
    var ruoli = this.authenticationService?.currentUserValue?.ruoliObject;
    var homepage = environment.homepages.find(x=> x.Ruoli.find(y=> ruoli && ruoli[0].id == y));
    return homepage?.link ?? environment.baseUrl
  }

  mostrapw() {
    this.mostrapassword = !this.mostrapassword;
  }
}
